import { styled } from '@mui/material/styles';
import { Box, Link } from '@mui/material';
import { VideoManagerItem } from '../../types/videos';
import SimpleVideoThumbnail from '../../common/SimpleVideoThumbnail';
import { VIDEO_STATUS } from '../../types/videoStatus';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Root = styled(Box)`
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
`;

const ThumbRoot = styled(Box)`
    position: relative;
`;

const ApprovalCheckbox = styled(CheckCircleIcon)`
    fill: red;
    position: absolute;
    right: -6px;
    top: -6px;
    background-color: white;
    border-radius: 50%;
`;

type HorizontalVideoProps = {
  video: VideoManagerItem;
  menu?: React.ReactElement;
  onClick: () => void;
}

export const VideoCard = ({ video, menu, onClick }: HorizontalVideoProps) => {
  const width = video.format === 'horizontal' ? 250 : 90;
  const thumbnail = new URL(video.thumbnail);
  thumbnail.searchParams.set('width', (width * 1.5).toString());
  return <Root>
    <ThumbRoot>
      <Link data-uuid={video.uuid} data-status={video.status} onClick={onClick}>
        <SimpleVideoThumbnail format={video.format} imageUrl={`${thumbnail.toString()}`} />
      </Link>
      {video.status === VIDEO_STATUS.APPROVED &&
        <ApprovalCheckbox titleAccess={'Approved'}/>}
    </ThumbRoot>
    {menu}
  </Root>;
};